/**
 * 章节列表数据服务（Axios 版本）
 * 替换原有的 WebSocket 实现
 */
import { ref } from 'vue';
import { getChapterIntroduce, getOneNovel } from './api';

export const chapterListWebSocket = (novel_id) => {
    const connected = ref(true); // Axios 总是"连接"状态
    const chapter_introduce = ref([]);
    const novels = ref({});
    const loading = ref(false);
    const error = ref(null);
    const errorItNovel = ref(null);

    // 请求章节列表和小说详情
    const fetchNovelsChapter = async () => {
        loading.value = true;
        error.value = null;
        errorItNovel.value = null;

        try {
            // 并行请求章节列表和小说详情
            const [chaptersResult, novelResult] = await Promise.all([
                getChapterIntroduce(novel_id),
                getOneNovel(novel_id)
            ]);

            // Result 结构：{ code: 0, msg: "success", data: [...] }
            if (chaptersResult.code === 0) {
                chapter_introduce.value = chaptersResult.data;
                console.log('获取章节信息成功');
            } else {
                error.value = chaptersResult.msg || '获取章节失败';
            }

            if (novelResult.code === 0) {
                novels.value = novelResult.data;
                console.log('获取小说信息成功');
            } else {
                errorItNovel.value = novelResult.msg || '获取小说信息失败';
            }
        } catch (err) {
            console.error('请求数据失败:', err);
            error.value = err.message || '请求数据失败';
            errorItNovel.value = err.message || '请求数据失败';
        } finally {
            loading.value = false;
        }
    };

    return {
        connected,
        chapter_introduce,
        novels,
        loading,
        error,
        errorItNovel,
        fetchNovelsChapter,
    };
};
